import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BusinessDataFormObject } from 'src/app/shared/models/business-data/business-data-form-object/business-data-form-object';

@Component({
  selector: 'app-business-data-form',
  templateUrl: './business-data-form.component.html',
  styleUrls: ['./business-data-form.component.scss'],
})
/**
 * Represents business data section of user register
 */
export class BusinessDataFormComponent implements OnInit {
  @Input() businessData!: BusinessDataFormObject;
  mask = '';

  /**
   * Init
   */
  ngOnInit() {
    this.getProvinces();
  }

  /**
   * @param {string} controlName
   * @return {FormControl}
   */
  getControl(controlName: string): FormControl {
    return this.businessData.formGroup.get(controlName) as FormControl;
  }

  /**
   * Changes state dropdown
   * @param {boolean} hasChanged
   * @return {any}
   */
  getProvinces(hasChanged?: boolean): any {
    const country = this.businessData.options.country.find(
      (a) => a.id === this.businessData.formGroup.get('country')?.value
    );
    /* const countryPrefix = phonePrefixes.find(
      (p) => p.code === country?.initials
    );

    this.mask = countryPrefix?.mask!; */

    const state = this.getControl('state');
    if (country?.provinces.length === 0) {
      country.provinces.push({ id: 0, name: 'N/A' });
      state.setValue('N/A');
    } else if (hasChanged) {
      state.setValue('');
    }

    return country?.provinces;
  }

  /**
   * Decides whether business contact email input is loading or not
   */
  get businessContactEmailInputType() {
    return (this.businessData.formGroup.pending && 'loading') || '';
  }
}
